import { Routes, Route, Navigate } from "react-router-dom";
import PersistLogin from "./components/PersistLogin";
import Login from "./features/auth/Login";
import Cognito from "./features/auth/Cognito";
import Layout from "./components/Layout";
import LandingPage from "./features/landing/LandingPage";
import ProgressPage from "./features/progress/ProgressPage";
import TasksPage from "./features/tasks/TasksPage";
import ChatPage from "./features/chat/ChatPage";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="cognito" element={<Cognito />} />
        <Route path="login" element={<Login />} />
        <Route element={<PersistLogin />}>
          <Route element={<Layout />}>
            <Route index element={<LandingPage />}></Route>
            <Route path="progress" element={<ProgressPage />}></Route>
            <Route path="tasks" element={<TasksPage />}></Route>
            <Route path="problems" element={<ChatPage />}>
              <Route index element={<ChatPage />}></Route>
              <Route path=":dialogId" element={<ChatPage />}></Route>
            </Route>
            <Route path="*" element={<Navigate to={"/"} replace />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default App;
